import { api } from "../../../../../../../utility/AxiosInceptor";
import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

import { useEffect } from "react";
import { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const EditUser = ({ setShowEditUser }) => {
  const [allRoles, setAllRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { rowData } = location.state || {};
  const navigate = useNavigate();
  // Get user data from ls
  const loginRes = localStorage.getItem("userData");
  const parseLoginRes = JSON.parse(loginRes);
  // Validation Schema
  const validationSchema = Yup.object().shape({
    role: Yup.string().required("Required"),
    name: Yup.string().required("Incorrect Name"),
    email: Yup.string().email("Incorrect Email").required("Email is Required"),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      role: "",
      name: "",
      email: "",

      city: "",
      state: "",

      zip: "",
      reportingTo: "",
      department: "",
    },
    onSubmit: async (values) => {
      setLoading(true);
      const data = {
        company: parseLoginRes?.company,
        createdBy: parseLoginRes?.createdDate,
        roleId: formik.values.role,
        reportingTo: formik.values.reportingTo,
        department: formik.values.department,
        userId: parseLoginRes?._id,
        name: values.name,
        email: values.email,
        password: values.password,
        city: values.city,
        zip: values.zip,
        state: values.state,
      };

      // Send the data to the server using Axios POST request
      api
        .post(`/api/web/user/`, data)
        .then((response) => {
          if (response?.status === 200) {
            toast.success(
              response?.data?.msg
                ? response?.data?.msg
                : "User Added Successfully"
            );
            setLoading(false);
            navigate("/manage-user");
          }
        })
        .catch((error) => {
          // Handle errors here
          toast.error(error?.response?.data?.msg);
        });
    },
  });
  const handleUserDataMapping = () => {
    if (rowData) {
      // Check if formik and rowData exist
      Object.keys(rowData).forEach((key) => {
        if (formik.initialValues.hasOwnProperty(key)) {
          formik.setFieldValue(key, rowData[key]);
          formik.setFieldValue("role", rowData?.role?._id);
        }
      });
    }
  };

  const getRoles = async () => {
    try {
      const res = await api.get(
        `/api/web/role/all?serviceProvider=${parseLoginRes?.company}`
      );

      setAllRoles(res?.data?.data || []);
    } catch (error) {}
  };
  useEffect(() => {
    const getDepartment = async () => {
      try {
        await api.get(
          `/api/deparments/getDepartments?company=${parseLoginRes?.company}`
        );
      } catch (error) {}
    };
    getDepartment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (formik.values.department) {
      const departId = formik.values.department;
      const getRoles = async () => {
        try {
          await api.get(
            `/api/web/user/getByDepartments?department=${departId}`
          );
        } catch (error) {}
      };
      getRoles();
    }
  }, [formik.values.department]);

  useEffect(() => {
    handleUserDataMapping();
    getRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="edituserdialog"
      style={{ marginLeft: "4rem" }}
    >
      <div className="edituserdialog">
        <div className="edituserform">
          <h1>Add User</h1>
          <p className="para">
            Enter the full name, email, and role for the new user.
          </p>
          <div style={{ marginTop: "2.4rem" }}>
            <div className="mb-3">
              <div className="flex justify-content-between w-full">
                <label htmlFor="name" className="labeltext mb-2">
                  Full Name
                </label>
                {formik.touched.name && formik.errors.name && (
                  <span className="p-error">{formik.errors.name}</span>
                )}
              </div>
              <InputText
                className={`w-full mb-3 ${formik.touched.name && formik.errors.name ? "input_texterror" : "input_text"}`}
                id="name"
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                keyfilter={/^[A-Za-z\s]+$/}
                placeholder="Name"
              />
            </div>
            <div className="mb-3">
              <div className="flex justify-content-between w-full">
                <label htmlFor="email" className="labeltext mb-2">
                  Email
                </label>
                {formik.touched.email && formik.errors.email && (
                  <span className="p-error">{formik.errors.email}</span>
                )}
              </div>
              <InputText
                className={`w-full mb-3 ${formik.touched.email && formik.errors.email ? "input_texterror" : "input_text"}`}
                id="email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="email"
                keyfilter={/^[a-zA-Z0-9_.@]*$/}
                placeholder="Email"
              />
            </div>

            <div>
              <div className="flex justify-content-between w-full">
                <label htmlFor="email" className="labeltext mb-2">
                  Role
                </label>
                {formik.touched.role && formik.errors.role && (
                  <span className="p-error">{formik.errors.role}</span>
                )}
              </div>
              <Dropdown
                className={`w-full mb-3 ${formik.touched.role && formik.errors.role ? "input_texterror" : "input_text"}`}
                id="role"
                options={allRoles}
                value={formik.values.role}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                optionLabel="role"
                optionValue="_id"
                keyfilter={/^[A-Za-z\s]+$/}
              />
            </div>
          </div>
        </div>
        <div
          className="flex  justify-content-end"
          style={{ height: "5rem", width: "63.6rem", marginTop: "4.8rem" }}
        >
          <Button
            className="mr-4 backbtn"
            type="button"
            label="Cancel"
            onClick={() => setShowEditUser(false)}
          />
          <Button
            type="submit"
            className="submitbtn"
            label="Submit"
            loading={loading}
          />
        </div>
      </div>
    </form>
  );
};

export default EditUser;
